import api from '../../../api/axios';

const BASE = '/v1/cuestionarios/mi-cuestionario';

export function useMiCuestionario() {
  const getMiCuestionario = () => api.get(`${BASE}/`);
  
  const getMiCuestionarioDetalle = (id) => api.get(`${BASE}/${id}/`);
  
  const responder = (data) => api.post(`${BASE}/responder/`, data);
  
  const responderBulk = (data) => api.post(`${BASE}/responder-bulk/`, data);
  
  const completar = (id) => api.post(`${BASE}/${id}/completar/`);
  
  const limpiar = (id) => api.delete(`${BASE}/${id}/limpiar/`);

  return {
    getMiCuestionario, getMiCuestionarioDetalle, responder, responderBulk, completar, limpiar,
  };
}
